import { TAuthToken } from "oms-utils/lib/esm/axios/_types";
import { axiosSetup } from "oms-utils";
import { AxiosResponse } from "axios";
import { ReadCookie } from "@services/cookie";
import { CookieKeys } from "@config";
import { api } from "@network/api";
import { store } from "@redux";
import { setPermission } from "@redux/actions/permissions";
import { ErrorDb } from "oms-ui-announcement";
import moment from "moment";

const findMessage = (error: any) => {
  if (error?.errorMessage) {
    return Array.isArray(error.errorMessage)
      ? error.errorMessage
      : [error.errorMessage];
  } else if (error.response?.data?.errorMessage) {
    return Array.isArray(error.response.data.errorMessage)
      ? error.response?.data?.errorMessage
      : [error.response?.data?.errorMessage];
  } else if (error.response?.data?.errors) {
    return Array.isArray(error.response.data.errors)
      ? error.response.data.errors
      : [error.response.data.errors];
  } else if (error.response?.data?.Message) {
    return Array.isArray(error.response.data.Message)
      ? error.response.data.Message
      : [error.response.data.Message];
  } else {
    return ["Something Went Wrong!"];
  }
};

const CookieRefreshToken = ReadCookie(CookieKeys.REFRESH_TOKEN);

export const {
  instance,
  CancelToken,
  setAuthToken,
  axiosGet,
  axiosPost,
  axiosPut,
  axiosDelete,
} = axiosSetup({
  requestConfig: {
    baseURL: api.BASE,
    headers: {
      "content-type": "application/json; charset=utf-8",
      "cache-control": "no-cache",
    },
  },
  retryConfig: {
    retries: 0,
    // retryDelay: (retryCount: number) => retryCount * 100,
  },
  refreshConfig: {
    URL: api.REFRESH,
    statusCode: 401,
    refreshData: {
      refreshToken: CookieRefreshToken.refreshToken,
      clientKey: "PANEL",
      defaultPosition: CookieRefreshToken.defaultPosition,
    },
    onFulfilled: (response: AxiosResponse, setAuthToken: TAuthToken) => {
      const { accessToken } = response.data;
      store.dispatch(setPermission(response.data));

      setAuthToken({
        token: accessToken,
        refreshData: {
          refreshToken: CookieRefreshToken.refreshToken,
          clientKey: "PANEL",
          defaultPosition: CookieRefreshToken.defaultPosition,
        },
      });
    },
    onRejected: () => {
      setAuthToken();
      window.location.replace(window._env_.WEB_DASHBOARD || "");
    },
  },
  onNotify: (status: number | undefined, data: any, response: any) => {},
  interceptorConfig: {
    onFulfilled: (res) => res,
    onRejected: (err) => {
      if (err.response) {
        ErrorDb.addObject({
          message: findMessage(err),
          title: window.location.pathname
            .split("/")
            .splice(1)
            .map((str) => str.charAt(0).toUpperCase() + str.slice(1))
            .join(" >> "),
          date: moment.now(),
          data: {
            url: err.response.config.url,
            request: err.response.config.data,
            response: err.response.data,
            status: err.response.status,
          },
        });
      }
      return Promise.reject(err);
    },
  },
});
